import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsListView } from '../programs/list/list';
import { RetailControllerModule } from './controllers/RetailController';
import { RetailEventsView } from './events/retailEvents';
import { RetailMembershipsView } from './memberships/memberships';

export const RetailView = angular
  .module('acme.view.application.retail', [
    uiRouter,
    'ui.bootstrap',
    RetailControllerModule,
    RetailEventsView,
    RetailMembershipsView,
    ProgramsListView,
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const retail = {
      name: 'application.retail',
      url: '/retail',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'RetailController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/retail/retail.tpl.html',
        },
      },
      data: {
        pageTitle: 'Retail',
        permissions: [
          'EVENT_VIEW',
          'EVENT_DELETE',
          'ORDER_REBOOK',
          'ORDER_CREATE',
          'ORDER_UPDATE',
          'ACCT_ORDERS_CREATE',
          'ACCT_ORDERS_UPDATE',
          'ORDER_VIEW',
          'MEMBERSHIP_SALES',
        ],
      },
    };

    $stateProvider.state(retail);
  }).name;
